import { useQuery } from '@tanstack/react-query'
import { api } from './api'

export type StokTuru = 'hammadde' | 'urun' | 'sarf' | 'yedek' | 'yakit'

export type Birim = {
  kod: string
  ad: string
  /** Doluysa birim yalnız bu türde önerilir. */
  tur: StokTuru | null
}

/**
 * Birim sözlüğü — süper adminin kütüphanesinden gelir, tesis tarafında
 * salt-okunurdur. Sözlük seyrek değişiyor, o yüzden uzun bayat süresi:
 * her form açılışında ağa çıkmak gereksiz.
 */
export function useBirimler(tur?: StokTuru) {
  return useQuery({
    queryKey: ['birimler', tur ?? 'tumu'],
    queryFn: () => api<Birim[]>(tur ? `/api/birimler?tur=${tur}` : '/api/birimler'),
    staleTime: 10 * 60_000,
  })
}

/**
 * Açılır listenin seçenekleri.
 *
 * <b>Kayıtta olan ama sözlükte bulunmayan değer listeye EKLENİR.</b> Aksi
 * hâlde birim kütüphaneden kaldırıldığında ya da kapatıldığında, o birimi
 * taşıyan eski bir kaydı açıp kaydetmek birimi sessizce listenin ilk
 * değerine çevirirdi — kullanıcı fark etmeden veri kaybı.
 *
 * Sıra korunur: önce sözlük sırası, sonra yalnız kayıtta kalanlar.
 */
export function birimSecenekleri(
  sozluk: readonly string[],
  kullanilan: readonly (string | null | undefined)[] = [],
): string[] {
  const acik = [...sozluk]
  const kalanlar = kullanilan
    .filter((k): k is string => !!k && k.trim() !== '')
    .filter((k) => !acik.includes(k))
  return [...new Set([...acik, ...kalanlar])]
}
